// extracted by mini-css-extract-plugin
export var minimal = "styles-module__minimal___SuNo_";